import { render, staticRenderFns } from "./RentTax.vue?vue&type=template&id=b4aa1fdc&scoped=true"
import script from "./RentTax.vue?vue&type=script&lang=js"
export * from "./RentTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4aa1fdc",
  null
  
)

export default component.exports